@use "sass:map";
@use "sass:string";

$emit-icss-exports: true !default;

$camel-case-widths: ();

$tiny: 375px;
$camel-case-widths: map.set($camel-case-widths, "tiny", $tiny);

$mobile: 768px;
$camel-case-widths: map.set($camel-case-widths, "mobile", $mobile);

$tablet: 1024px;
$camel-case-widths: map.set($camel-case-widths, "tablet", $tablet);

$laptop: 1200px;
$camel-case-widths: map.set($camel-case-widths, "laptop", $laptop);

$desktop: 1440px;
$camel-case-widths: map.set($camel-case-widths, "desktop", $desktop);

// Inspired by https://wptips.dev/better-sass-media-query/
$below-tiny: "max-width: #{$tiny - 1}";
$above-tiny: "min-width: #{$tiny}";

$below-mobile: "max-width: #{$mobile - 1}";
$above-mobile: "min-width: #{$mobile}";

$below-tablet: "max-width: #{$tablet - 1}";
$above-tablet: "min-width: #{$tablet}";

$below-laptop: "max-width: #{$laptop - 1}";
$above-laptop: "min-width: #{$laptop}";

$below-desktop: "max-width: #{$desktop - 1}";
$above-desktop: "min-width: #{$desktop}";

@if $emit-icss-exports {
    :export {
        @each $name, $value in $camel-case-widths {
            #{string.unquote($name)}: $value;
        }
    }
}
